var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-heading",class:_vm.color},[_c('line-svg',{attrs:{"color":(_vm.color + "-stroke")}}),_vm._v(" "),_c('h3',{staticClass:"h3"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }